import React from 'react';
import { BringzzText, BringzzImage, BringzzIcon } from "@bringzz/components";
import classNames from 'classnames';
import DefaultProductImage from 'assets/DefaultProductImage.png';

const PharmacyTab = ({ pharmacies, isAllCategory, onItemClick, toggleBookmark }) => {
    const renderPharmacyItem = (pharmacy, index, section) => {
        if (isAllCategory) {
            return (
                <div key={`${section}-${pharmacy.id}-${index}`} className='flex items-center border-b py-2 cursor-pointer' onClick={() => onItemClick(pharmacy, 'pharmacy')}>
                    <BringzzText tag='h4'>{pharmacy.name}</BringzzText>
                </div>
            );
        }
        
        return (
            <div key={`${section}-${pharmacy.id}-${index}`} className='flex items-center border-b py-2'>
                {pharmacy.image ? (
                    <BringzzImage 
                        src={pharmacy.image} 
                        className='h-10 w-10 mr-2 cursor-pointer rounded'
                        onClick={() => onItemClick(pharmacy, 'pharmacy')}
                    />
                ) : (
                    <BringzzImage 
                        src={DefaultProductImage} 
                        className='h-8 w-8 mr-2 cursor-pointer rounded opacity-50'
                        onClick={() => onItemClick(pharmacy, 'pharmacy')}
                    />
                )}
                <div className='flex flex-col flex-grow cursor-pointer' onClick={() => onItemClick(pharmacy, 'pharmacy')}>
                    <BringzzText tag='h3'>{pharmacy.name}</BringzzText>
                    {pharmacy.telefon && <BringzzText tag='h4' className='font-normal text-gray-600'>{pharmacy.telefon}</BringzzText>}
                    {pharmacy.city && <BringzzText tag='h5' className='text-gray-500'>{pharmacy.city}</BringzzText>}
                    {pharmacy.statusText && (
                        <BringzzText tag='h5' className={`font-medium ${pharmacy.statusColor || (pharmacy.isOpen ? 'text-green-600' : 'text-red-600')}`}>
                            {pharmacy.statusText}
                        </BringzzText>
                    )}
                </div>

            </div>
        );
    };

    return { renderPharmacyItem };
};

export default PharmacyTab;